"use strict";

angular.module("core")
.controller("UserVerificationModalController", function(
    $scope, $attrs, close, gettextCatalog, FormError, FlashBag, UserVerificationService, PatternService, EMAIL_MAXLENGTH
) {
    var _this = this;
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.OTHER = 'other';
    $scope.pattern = PatternService;
    $scope.message = $attrs.verificationMessage;
    $scope.isVerificationCodeSent = false;
    $scope.verificationCodeFormData = {};

    setUserVerificationFormData($attrs.userData);

    function setUserVerificationFormData(userData) {
        $scope.userData = userData;
        $scope.userVerificationFormData = {
            "email": userData.email,
            "phone": userData.cell_phone
        };
        if (!$scope.userData.is_phone_valid) {
            $scope.userVerificationFormData["phone"] = $scope.OTHER;
            $scope.userVerificationFormData["override_phone"] = userData.cell_phone;
        }
    }

    this.resetUserVerificationForm = function() {
        $scope.userVerificationForm.$setPristine();
    };

    this.resetVerificationCode = function() {
        UserVerificationService.getUserData($attrs.verificationType)
        .then(function onSuccess(response) {
            setUserVerificationFormData(response.data);
            $scope.isVerificationCodeSent = false;
            _this.resetUserVerificationForm();
        }, function onError(response) {
            var errorMessage = FlashBag.formatErrorResponse(response);
            FlashBag.alertWithContainer("danger", "flash-user-verification-modal", errorMessage);
        });
    }

    function parseUserVerificationFormData() {
        var method = $scope.userVerificationFormData.method;
        var data = {"method": method};
        if ($scope.userVerificationFormData[method] === $scope.OTHER) {
            data["override_" + method] = $scope.userVerificationFormData['override_' + method];
            data["password"] = $scope.userVerificationFormData.password;
        }
        else {
            data[method] = $scope.userVerificationFormData[method];
        }
        return data;
    }

    this.sendVerificationCode = function() {
        $scope.userVerificationForm.$setSubmitted();
        FlashBag.clearAll();

        if (!$scope.userVerificationForm.$valid) {
            FormError.focus("userVerificationForm");
            return;
        }

        var data = parseUserVerificationFormData();
        UserVerificationService.sendVerificationCode($attrs.verificationType, data)
        .then(function onSuccess() {
            $scope.isVerificationCodeSent = true;
            $scope.verificationCodeForm.$setPristine();
            var alertMessage = gettextCatalog.getString("Your should receive your code shortly.");
            FlashBag.alertWithContainer("success", "flash-user-verification-modal", alertMessage);
        }, function onError(response) {
            var errorMessage = FlashBag.formatErrorResponse(response);
            FlashBag.alertWithContainer("danger", "flash-user-verification-modal", errorMessage);
        });

    };

    this.validateVerificationCode = function() {
        $scope.verificationCodeForm.$setSubmitted();
        FlashBag.clearAll();

        if (!$scope.verificationCodeForm.$valid) {
            FormError.focus("verificationCodeForm");
            return;
        }

        UserVerificationService.validateVerificationCode($attrs.verificationType, $scope.verificationCodeFormData)
        .then(function() {
            _this.close(true);
        }, function(response) {
            var errorMessage = "";
            if (response.status === 404) {
                errorMessage = gettextCatalog.getString("Invalid verification code");
            }
            else {
                errorMessage = FlashBag.formatErrorResponse(response);
            }
            FlashBag.alertWithContainer("danger", "flash-user-verification-modal", errorMessage);
        });
    };

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.isEmailOverrideValid = function() {
        return $scope.userVerificationForm && (
            (
                $scope.userVerificationForm.override_email.$error.maxlength
                || $scope.userVerificationForm.override_email.$error.pattern
            ) || (
                $scope.userVerificationForm.$submitted
                && $scope.userVerificationForm.override_email.$error.required
            )
        );
    }

    this.isPhoneOverrideValid = function() {
        return $scope.userVerificationForm && (
            !$scope.userVerificationForm.override_phone.$valid || (
                $scope.userVerificationForm.$submitted
                && $scope.userVerificationForm.override_phone.$error.required
            )
        );
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/user-verification/modals/user-verification.modal.js
// module id = 660
// module chunks = 0